import React from "react";

function Avatar(props) {

    return (
        <>
            <style jsx="true">{`
                .team-member {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 250px;
                }

                .team-member-image {
                    width: 220px;
                    height: 220px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-bottom: 30px;
                    border: 0.5rem solid rgba(0, 0, 0, 0.1);
                    box-shadow: 0 0 5px #DBA800;
                }

                .team-member-image:hover {
                    transform: scale(1.1);
                }

                .team-member-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .member-name {
                    font-size: 24px;
                    font-weight: 600;
                    color: #000;
                    margin: 0 0 5px 0;
                    text-align: center;
                }

                .member-title {
                    font-size: 16px;
                    color: #666;
                    margin: 0;
                    text-align: center;
                    font-weight: 400;
                }

                @media (max-width: 768px) {
                    .team-member {
                        width: 200px;
                    }

                    .team-member-image {
                        width: 180px;
                        height: 180px;
                        border-width: 8px;
                    }

                    .member-name {
                        font-size: 20px;
                    }
                }

                @media (max-width: 576px) {
                    .team-member {
                        width: 160px;
                    }

                    .team-member-image {
                        width: 150px;
                        height: 150px;
                        border-width: 6px;
                        margin-bottom: 20px;
                    }

                    .member-name {
                        font-size: 18px;
                    }

                    .member-title {
                        font-size: 14px;
                    }
                }
            `}</style>
            <div className="team-member">
                <div className="team-member-image">
                    <img src={props.imageSrc} alt={props.imageAlt}/>
                </div>
                <h2 className="member-name">{props.avatarName}</h2>
                <p className="member-title">{props.avatarTitle}</p>
            </div>
        </>
    );
}

export default Avatar;